import { PageHeader, Spinner } from '@lmc/ui-kit'
import useResident from 'hooks/useResident'
import { NAMESPACE } from 'locale'
import { emarV2Constants } from 'locale/emarV2'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router-dom'
import PageWrapper from '../componentsV2/PageWrapper'
import { useAddMedicationButtonState } from '../hooks/useAddMedicationButtonState'
import { useAddMedicationFacelift } from '../hooks/useAddMedicationFacelift'

export const AddMedicationScreen = () => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const { id: residentId } = useParams<{ id: string }>()
  const { resident, isLoading: isLoadingResident } = useResident({
    id: residentId
  })
  const { isEnabled, isLoading: isLoadingFlags } = useAddMedicationFacelift()
  const { disabled: cannotAddMedication } =
    useAddMedicationButtonState(resident)

  if (isLoadingFlags || isLoadingResident || !resident) {
    return (
      <PageWrapper>
        <Spinner style={{ marginTop: '80px' }} />
      </PageWrapper>
    )
  }

  // Reached by URL with the flag off, or by someone the add medication button
  // would have stopped
  if (!isEnabled || cannotAddMedication) {
    return (
      <Navigate to={`/residents/${residentId}/emar/medication-list`} replace />
    )
  }

  return <PageHeader title={t(emarV2Constants.ADD_MEDICATION_TITLE)} sticky />
}

export default AddMedicationScreen
